export const isReferencing = (): boolean => {
  const selfQueryParams = new URLSearchParams(window.location.search);
  return selfQueryParams.get('referencing') === 'true';
};
